import React, { useState } from "react";
import { Wand2, Loader2, Sparkles } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";
import { Modal } from '@ui';
import { useToast } from "../../../context/ToastContext";

const RedrawModal = ({ isOpen, onClose, onConfirm, originalImage }) => {
  const { getTheme } = useTheme();
  const theme = getTheme();
  const toast = useToast();
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!prompt.trim()) { toast.warning("请输入修改指令"); return; }
    setLoading(true);
    await onConfirm(prompt);
    setLoading(false);
    onClose();
    setPrompt("");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={<span className="flex items-center gap-2"><Wand2 style={{ color: theme.colors.bluePrimary }} size={20} /> AI 局部重绘</span>} width="max-w-[600px]">
      <div className="flex flex-col gap-4">
        <div className="flex gap-4">
          <div className="w-1/3 aspect-video rounded-lg overflow-hidden relative" style={{ backgroundColor: 'var(--color-bg-primary)', border: '1px solid var(--color-border-primary)' }}>
            <img
              src={originalImage}
              className="w-full h-full object-cover opacity-60"
              alt="ref"
            />
            <div className="absolute inset-0 flex items-center justify-center text-2xs font-bold uppercase tracking-widest" style={{ color: 'var(--color-text-muted)' }}>
              参考底图
            </div>
          </div>
          <div className="flex-1 text-xs leading-relaxed space-y-2" style={{ color: 'var(--color-text-secondary)' }}>
            <p>AI 将保留原图构图，仅根据指令修改。</p>
          </div>
        </div>
        <div className="space-y-2">
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            className="w-full h-24 rounded-xl p-3 text-sm outline-none resize-none"
            style={{ backgroundColor: 'var(--color-bg-overlay)', border: '1px solid var(--color-border-primary)', color: 'var(--color-text-primary)' }}
            placeholder="输入修改要求..."
            autoFocus
          />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button
            onClick={onClose}
            className="px-4 py-2.5 rounded-lg text-xs font-bold transition-all duration-200"
            style={{ color: 'var(--color-text-muted)' }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-bg-tertiary)'; e.currentTarget.style.color = 'var(--color-text-primary)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = 'var(--color-text-muted)'; }}
          >
            取消
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-6 py-2.5 rounded-lg text-xs font-bold flex items-center gap-2 disabled:opacity-50 transition-all duration-200"
            style={{ background: `linear-gradient(to right, ${theme.colors.bluePrimary}, ${theme.colors.accentPrimary})`, color: 'white' }}
            onMouseEnter={(e) => { if (!loading) { e.currentTarget.style.boxShadow = `0 4px 16px ${theme.colors.accentGlow}`; e.currentTarget.style.filter = 'brightness(1.1)'; }}}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.filter = 'none'; }}
          >
            {loading ? (
              <Loader2 size={14} className="animate-spin" />
            ) : (
              <Sparkles size={14} />
            )}{" "}
            开始重绘
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RedrawModal;
